import { RootState } from "../../../../store";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";
import { ResourceExplorerDimension } from "../../../utils/types/resourceExplorer";

export const resourceExplorerDimensionSelector = (
  state: RootState,
): ResourceExplorerDimension | null => {
  return resourceExplorerStateSelector(state).dimension;
};
